import { render, staticRenderFns } from "./CartMenu.vue?vue&type=template&id=b373e7ac&scoped=true"
import script from "./CartMenu.vue?vue&type=script&lang=js"
export * from "./CartMenu.vue?vue&type=script&lang=js"
import style0 from "./CartMenu.vue?vue&type=style&index=0&id=b373e7ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b373e7ac",
  null
  
)

export default component.exports